import React, { useState, useEffect, useContext, useCallback } from "react";
import useLocalStorage from "../Hooks/useLocalStorage";
const UIContext = React.createContext([{}, () => {}]);
const VIEW_CONSTS = {
  matchSelect: 0,
  live: 1,
  formation: 2,
  stats: 3,
  clockEdit: 4,
  all_graphics: 5,
  penalty: 6,
};

const MODE_CONSTS = {
  live: 0,
  matchChoice: 1,
};

const UIProvider = (props) => {
  const [view, setView] = useState(VIEW_CONSTS.matchSelect);
  const [mode, setMode] = useState(MODE_CONSTS.live);
  const [goal, setGoal] = useState();
  const [selectedTeam, setSelectedTeam] = useState();
  const [editPlayer, setEditPlayer] = useState();
  const [uiView, setUIView] = useState(0);
  const [periods, setPeriods] = useState([]);
  const [homeScorers, setHomeScorers] = useState([]);
  const [awayScorers, setAwayScorers] = useState([]);
  const [homePenalties, setHomePenalties] = useState([]);
  const [awayPenalties, setAwayPenalties] = useState([]);
  const [editUI, setEditUI] = useState(false);
  const [uiProfile, setUIProfile] = useState();
  const [uiProfileJSON, setUIProfileJSON] = useState("ui-profile", {
    middle: [],
    right: [],
  });
  useEffect(() => {
    let profile = new UIProfile({});
    profile.load({ data: uiProfileJSON });
    setUIProfile(profile);
  }, [uiProfileJSON]);
  return (
    <UIContext.Provider
      value={{
        view,
        setView,
        selectedTeam,
        setSelectedTeam,
        goal,
        setGoal,
        mode,
        setMode,
        editPlayer,
        setEditPlayer,
        uiView,
        setUIView,
        periods,
        setPeriods,
        homeScorers,
        setHomeScorers,
        awayScorers,
        setAwayScorers,
        homePenalties,
        setHomePenalties,
        awayPenalties,
        setAwayPenalties,
        editUI,
        setEditUI,
        uiProfile,
        setUIProfile,
        uiProfileJSON,
        setUIProfileJSON,
      }}
    >
      {props.children}
    </UIContext.Provider>
  );
};

export class UIProfile {
  constructor({ data }) {
    if (!!UIProfile.instance) {
      return UIProfile.instance;
    }

    UIProfile.instance = this;
    if (data) {
      this.load({ data });
    }
    return this;
  }

  load({ data }) {
    this.root = new TreeNode({ data: { name: "ROOT" } });
    this.middle = new TreeNode({ data: { name: "MIDDLE" } });
    this.right = new TreeNode({ data: { name: "RIGHT" } });
    this.root.addChild(this.middle);
    this.root.addChild(this.right);
    for (
      let i = 0;
      i <
      data?.middle?.filter((i) => {
        return i.enabled;
      })?.length;
      i++
    ) {
      let node = new TreeNode({
        data: data.middle?.filter((i) => {
          return i.enabled;
        })[i],
      });
      this.middle.addChild(node);
    }
    for (
      let i = 0;
      i <
      data?.right?.filter((i) => {
        return i.enabled;
      })?.length;
      i++
    ) {
      let node = new TreeNode({
        data: data.right?.filter((i) => {
          return i.enabled;
        })[i],
      });
      this.right.addChild(node);
    }
  }

  toJSON() {
    return {
      middle: this.middle.children.map((item) => item.toJSON()),
      right: this.right.children.map((item) => item.toJSON()),
    };
  }

  getInstance() {
    return this;
  }
}

class TreeNode {
  constructor({ data }) {
    this.data = data;
    this.children = [];

    if (data?.tabs) {
      for (let i = 0; i < data.tabs.length; i++) {
        let tab = new TreeNode({ data: data.tabs[i] });

        this.children.push(tab);
      }
    } else if (data?.items) {
      for (let i = 0; i < data.items.length; i++) {
        let item = new TreeNode({ data: data.items[i] });

        this.children.push(item);
      }
    }
  }

  toJSON() {
    let json = { ...this.data };

    if (json.type === "TABS") {
      json.tabs = this.children.map((tab) => tab.toJSON());
    }
    if (this.children.length > 0) {
      json.items = this.children.map((tab) => tab.toJSON());
    }
    return json;
  }

  addChild(child) {
    if (child instanceof TreeNode) {
      this.children.push(child);
    } else {
      this.children.push(new TreeNode(child));
    }
  }

  removeChild(childToRemove) {
    const length = this.children.length;
    this.children = this.children.filter((child) => {
      return childToRemove instanceof TreeNode
        ? child !== childToRemove
        : child.data !== childToRemove;
    });

    if (length === this.children.length) {
      this.children.forEach((child) => child.removeChild(childToRemove));
    }
  }

  print(level = 0) {
    let result = "";
    for (let i = 0; i < level; i++) {
      result += "-- ";
    }
    console.log(`${result}${this.data}`);
    this.children.forEach((child) => child.print(level + 1));
  }

  depthFirstTraversal() {
    console.log(this.data);
    this.children.forEach((child) => child.depthFirstTraversal());
  }

  breadthFirstTraversal() {
    let queue = [this];
    while (queue.length > 0) {
      const current = queue.shift();
      console.log(current.data);
      queue = queue.concat(current.children);
    }
  }
}

export { UIContext, UIProvider, VIEW_CONSTS, MODE_CONSTS };
